module.exports = __webpack_public_path__ + "static/07-2ddcf7f98ef8a9926f938a1c13a35351.jpg";